import React from 'react';
import FormItem from '@/components/ui/FormItem';
import InputText from '@/components/ui/InputText';
import type { FormItemProps } from '@/components/views/Resolution886/types';

export function EvaluationNameFormItem({ fieldName = '', required = true }: Readonly<FormItemProps>): JSX.Element {
	return (
		<FormItem
			required={required}
			name={fieldName}
			label="Evaluation name"
			requiredMessage="Please enter an evaluation name"
		>
			<InputText placeholder="Evaluation name" />
		</FormItem>
	);
}
